import React from 'react'
import Footer from '../Footer/Footer'
import PeertoPeer from '../Home/PeertoPeer'

const Trnasfer = () => {
  return (
    <div className='pt-5 '><PeertoPeer/>
    <Footer/>
    </div>
  )
}

export default Trnasfer